import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

/**
 * Fetch the service report.
 * @param {Object} filters - { start_date, end_date, service_type, customer_name }
 */
export const getServiceReport = async (filters = {}) => {
  const params = Object.fromEntries(
    Object.entries(filters).filter(([, v]) => v !== "" && v !== null && v !== undefined)
  );
  const response = await axios.get(`${BASE}/reports/service-report`, { params });
  return response.data;
};
